module.exports = __webpack_public_path__ + "static/fuel-pump-b38eeb3da367a0f087294c9e0b1788ba.jpg";